export const colors = {
  black: '#000',
  white: '#fff',
  primary: '#F9CE42',
  primaryLinearGradient: 'linear-gradient(rgb(250,206,66), rgb(250,211,85))',
  modalBackground: 'rgba(255, 255,255, 0.2)',
  danger: '#FF5028'
};
